import { useNavigate } from 'react-router-dom';
import * as CompactChartHeaderUI from './CompactChartHeaderUI';
import ChartHeaderDateRange from '../ChartHeaderDateRange';
import { useChartContext } from '../../ChartContext';
import * as ChartUI from '../../ChartUI';
import ChartHeaderDisplay from '../ChartHeaderDisplay';
import ChartHeaderFavorite from '../ChartHeaderFavorite';

const CompactChartHeader = () => {
  const navigate = useNavigate();
  const {
    metadata: { reportLink, mode, display },
  } = useChartContext();

  const handleClick = () => {
    navigate(reportLink);
  };

  return (
    <ChartUI.Header onClick={handleClick} $mode={mode}>
      <CompactChartHeaderUI.ChartDisplayContainer>
        <ChartHeaderDisplay mode={mode} chartTitle={display} />
        <ChartHeaderFavorite />
      </CompactChartHeaderUI.ChartDisplayContainer>
      <ChartHeaderDateRange />
    </ChartUI.Header>
  );
};

export default CompactChartHeader;
